import { REGISTER_PATH_AS as path } from 'constants/paths';
import { Loadable } from 'utils/components';

export default {
  path,
  component: Loadable({
    loader: () => import(/* webpackChunkName: 'RegisterAS' */ './components/RegisterPageAS')
  })
};
